import { createRouter, createWebHistory } from 'vue-router';
import vueConfig from '../../vue.config';
import Home from '@/views/HomeView.vue';
import PoliticaCookies from '@/views/contenido/legal/PoliticaCookies.vue';
import TerminosCondiciones from '@/views/contenido/legal/TerminosCondiciones.vue';
import AvisoLegal from '@/views/contenido/legal/AvisoLegal.vue';
import Faqs from '@/views/contenido/legal/FaqsSection.vue';
import PoliticaCamasLibres from '@/views/contenido/legal/PoliticaCamasLibres.vue';
import Landing from '@/views/landing/LandingView.vue';
import CondicionesCovid from '@/views/contenido/legal/CondicionesCovid.vue';
import UsuarioActivacion from '@/views/usuario/UsuarioActivacion.vue';
import UsuarioPerfil from '@/views/usuario/UsuarioPerfil.vue';
import UsuarioRooming from '@/views/usuario/UsuarioRooming.vue';
import UsuarioProximasReservas from '@/views/usuario/UsuarioProximasReservas.vue';
import UsuarioProximasReservasDetalle from '@/views/usuario/UsuarioProximasReservasDetalle.vue';
import UsuarioProximasReservasModificar from '@/views/usuario/UsuarioProximaReservasModificar.vue';
import UsuarioProximasReservasConfirmacion from '@/views/usuario/UsuarioProximaReservasConfirmacion.vue';
import UsuarioDarBajaPublicidad from '@/views/usuario/UsuarioDarBajaPublicidad.vue';
import AreaComercial from '@/views/usuario/staff/AreaComercial.vue';
import AgrupacionDetalle from '@/views/productos/agrupaciones/AgrupacionesExperienciasLanding.vue';
import UsuarioPasswordRecordar from '@/views/usuario/UsuarioPasswordRecordar/UsuarioPasswordRecordar.vue';
import UsuarioPasswordEstablecer from '@/views/usuario/UsuarioPasswordEstablecer.vue';
import PaginasLanding from '@/views/productos/pagina/PaginasLanding.vue';
import Buscador from '@/views/productos/catalogo/CatalogoBuscador.vue';
import BuscadorServicios from '@/views/productos/seleccion/SeleccionBuscador.vue';
import BuscadorResumenReserva from '@/views/productos/resumen/ResumenBuscador.vue';
import * as RouterNames from '@/router/RouterNames';
import NotFound from '@/components/NotFound';
import TrabajaConNosotros from 'src/views/contenido/nosotros/TrabajaConNosotros.vue';
import QuienesSomos from 'src/views/contenido/nosotros/QuienesSomos.vue';
import BlogLanding from '@/views/contenido/blog/BlogLanding.vue';
import blogPost from '@/views/contenido/blog/BlogPost.vue';
import CheckInReserva from '../views/reservas/CheckInReserva.vue';
import InformacionAlojamiento from '@/views/productos/informacion/AlojamientosLanding.vue';
import { redireccionRutas } from '@/router/redirecciones';
import { appGlobalStore } from '@/store_pinia/app';
import { useLoginStore } from '@/store_pinia/login';
import PoliticaPrivacidad from '@/views/contenido/legal/PoliticaPrivacidad.vue';
import { useUserStore } from '@/store_pinia/userStore';
import { agenciaStoreModule } from '@/store_pinia/agencia';
import { isTokenExpired } from '@/services/utils/securityUtils';
import i18n from '@/i18n';

const { t } = i18n.global;
const BASE_VIAJES_GRUPOS = 'grupos/viajes';

const routes = [
  //////////////////////////////////////////////////////////////
  ///////////////////         LANDING        ///////////////////
  //////////////////////////////////////////////////////////////
  {
    path: vueConfig.publicPath,
    name: RouterNames.Home,
    component: PaginasLanding,
    meta: {
      title: t('seo.home.title'),
      description: t('seo.home.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'pages/:uri',
    name: RouterNames.PaginasLanding,
    component: PaginasLanding,
  },
  {
    path: '/buscador',
    name: RouterNames.Buscador,
    component: Buscador,
  },
  {
    path: '/buscador/alojamientos/:idAlojamiento',
    name: RouterNames.BuscadorAlojamiento,
    component: InformacionAlojamiento,
  },
  {
    path: '/buscador/servicios',
    name: RouterNames.BuscadorServicios,
    component: BuscadorServicios,
  },
  {
    path: '/buscador/reserva',
    name: RouterNames.BuscadorResumen,
    component: BuscadorResumenReserva,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS,
    name: RouterNames.ViajesGrupoCatalogo,
    component: () => import('src/views/productos/catalogo/CatalogoViajesGrupo.vue'),
    props: route => ({
      areaDestino: route.query.areaDestino,
      lugarExperienciaDestino: route.query.lugarExperienciaDestino,
      tipoGrupo: route.query.tipoGrupo,
    }),
    meta: {
      title: t('seo.catalogoGrupos.title'),
      description: t('seo.catalogoGrupos.description'),
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/alojamientos',
    name: RouterNames.GruposReservaAlojamientos,
    component: () => import('src/views/productos/seleccion/SeleccionAlojamiento.vue'),
    meta: {
      poweredByEnabled: true,
      requiresLoginHomologados: true,
    },
  },
  {
    path: vueConfig.publicPath + 'alojamientos/:idAlojamiento',
    name: RouterNames.InformacionAlojamiento,
    component: () => import('@/views/productos/informacion/AlojamientosLanding.vue'),
    meta: {
      title: t('seo.landingAlojamiento.title'),
      description: t('seo.landingAlojamiento.description'),
    },
  },
  {
    path:
      vueConfig.publicPath +
      BASE_VIAJES_GRUPOS +
      '/:viajeId/alojamientos/:hotelId/:numPlazas/:plazasReales/:tipoHabId/:precioCupoSinMarkupProrrateado/:tipoRegimenId/:integrado/:cacheTimestamp/:cupoId?',
    name: RouterNames.GruposReservaFormulario,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoSeleccionServicios.vue'),
    meta: {
      poweredByEnabled: true,
      requiresLoginHomologados: true,
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/modificarReservas',
    name: RouterNames.ViajesGrupoModificarReservas,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoSeleccionServicios.vue'),
    meta: {
      poweredByEnabled: true,
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/unirse/:codigoGrupo',
    name: RouterNames.GruposReservaFormularioUnirse,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoSeleccionServicios.vue'),
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/unirse',
    name: RouterNames.GruposReservaFormularioUnirseSinAlojamiento,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoSeleccionServicios.vue'),
    meta: {
      poweredByEnabled: true,
      requiresLoginHomologados: true,
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/confirmacion',
    name: RouterNames.GruposReservaResumen,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoResumenReserva.vue'),
    meta: {
      requiresLogin: true,
      poweredByEnabled: true,
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId/propuesta/confirmacion',
    name: RouterNames.GruposPropuestaResumen,
    component: () => import('src/modules/viajesGrupos/views/ViajesGrupoResumenPropuesta.vue'),
    meta: {
      requiresLogin: false,
      poweredByEnabled: false,
    },
  },
  {
    path: vueConfig.publicPath + '/pay-thanks',
    name: RouterNames.GruposViajesThankYouRedireccion,
    component: () => import('src/views/common/success/SuccessPagoRedireccion.vue'),
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/thanks/:grupoId',
    name: RouterNames.GruposViajesThankYou,
    component: () => import('src/views/common/success/SuccessPago.vue'),
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/thanks/propuesta/rechazo/:viajeId',
    name: RouterNames.GruposPropuestaRechazoThankYou,
    component: () => import('src/views/common/success/SuccessRechazoInvitacionGrupo.vue'),
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/thanks/propuesta/:viajeId',
    name: RouterNames.GruposPropuestaThankYou,
    component: () => import('src/views/common/success/SuccessPagoInvitacionGrupo.vue'),
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + '/pay-problem',
    name: RouterNames.GruposViajesErrorPago,
    component: () => import('src/views/common/error/ErrorPago.vue'),
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/:viajeId',
    name: RouterNames.GruposInformacionViaje,
    component: () => import('@/views/productos/informacion/ExperienciasLanding.vue'),
    props: true,
    meta: {
      poweredByEnabled: true,
      title: t('seo.landingExperiencia.title'),
      description: t('seo.landingExperiencia.description'),
    },
  },
  {
    path: vueConfig.publicPath + BASE_VIAJES_GRUPOS + '/resumenPdf/:viajeId',
    name: RouterNames.ViajeResumenPDF,
    component: () => import('@/views/productos/informacion/ResumenPDF.vue'),
    props: true,
  },
  //////////////////////////////////////////////////////////////
  ///////////////////         USUARIO        ///////////////////
  //////////////////////////////////////////////////////////////
  // {
  // 	path: vueConfig.publicPath + 'ofertas-nieve/:uri',
  // 	name: RouterNames.Landing,
  // 	component: Landing
  // },
  {
    path: vueConfig.publicPath + ':uri1/:uri2?/:uri3?',
    name: RouterNames.Landing,
    component: Landing,
  },
  {
    path: vueConfig.publicPath + 'usuario/perfil',
    name: 'perfil',
    component: UsuarioPerfil,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'usuario/proximasreservas',
    name: RouterNames.UsuarioProximasReservas,
    component: UsuarioProximasReservas,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'usuario/rooming',
    name: RouterNames.UsuarioRooming,
    component: UsuarioRooming,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'usuario/proximasreservas/:grupoId',
    name: RouterNames.UsuarioProximasReservasDetalle,
    component: UsuarioProximasReservasDetalle,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'usuario/proximasreservas/:grupoId/modificar',
    name: RouterNames.UsuarioProximaReservasModificar,
    component: UsuarioProximasReservasModificar,
    meta: { requiresLogin: true },
  },
  {
    // Mantener url por google analitics
    path: vueConfig.publicPath + 'grupos/proximasreservas/:grupoId/confirmacion',
    name: RouterNames.UsuarioProximaReservasConfirmacion,
    component: UsuarioProximasReservasConfirmacion,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'usuario/password/recordar',
    name: 'UsuarioPasswordRecordar',
    component: UsuarioPasswordRecordar,
  },
  {
    path: vueConfig.publicPath + 'usuario/activacion/:codigo',
    name: 'UsuarioActivacion',
    component: UsuarioActivacion,
  },
  {
    path: vueConfig.publicPath + 'usuario/password/establecer/:codigo',
    name: 'UsuarioPasswordEstablecer',
    component: UsuarioPasswordEstablecer,
  },
  {
    path: vueConfig.publicPath + 'usuario/password/recordar',
    name: 'UsuarioPasswordRecordar',
    component: UsuarioPasswordRecordar,
  },
  {
    path: vueConfig.publicPath + '/baja-emails-promocionales/:codigo',
    name: 'UsuarioDarBajaPublicidad',
    component: UsuarioDarBajaPublicidad,
  },
  {
    path: vueConfig.publicPath + 'usuario/registro/ficticioToReal/:uuid',
    name: RouterNames.RegistroFicticioToReal,
    component: Home,
    beforeEnter: (to, from, next) => {
      const loginStore = useLoginStore();
      const userStore = useUserStore();
      if (userStore.isLogged) {
        userStore.logout();
      }
      next();
      loginStore.openLoginModal();
    },
  },

  //////////////////////////////////////////////////////////////
  ///////////////////     AREA COMERCIAL     ///////////////////
  //////////////////////////////////////////////////////////////
  {
    path: vueConfig.publicPath + 'areaComercial',
    name: RouterNames.AreaComercial,
    component: AreaComercial,
    meta: { requiresLogin: true },
  },

  //////////////////////////////////////////////////////////////
  //////////////         AGRUPACIONES				     ///////////////
  //////////////////////////////////////////////////////////////
  {
    path: vueConfig.publicPath + 'agrupaciones/:uri',
    name: RouterNames.AgrupacionDetalle,
    component: AgrupacionDetalle,
    meta: {
      title: t('seo.landingAgrupacion.title'),
      description: t('seo.landingAgrupacion.description'),
    },
  },

  //////////////////////////////////////////////////////////////
  ///////////////////          LEGAL         ///////////////////
  //////////////////////////////////////////////////////////////
  {
    path: vueConfig.publicPath + 'legal/avisoLegal',
    name: 'AvisoLegal',
    component: AvisoLegal,
    meta: {
      title: t('seo.avisoLegal.title'),
      description: t('seo.avisoLegal.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'legal/terminosCondiciones/:viajeId?',
    name: 'TerminosCondiciones',
    component: TerminosCondiciones,
    meta: {
      title: t('seo.terminosCondiciones.title'),
      description: t('seo.terminosCondiciones.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'legal/politicaCookies',
    name: 'PoliticaCookies',
    component: PoliticaCookies,
    meta: {
      title: t('seo.politicaCookies.title'),
      description: t('seo.politicaCookies.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'legal/politicaPrivacidad',
    name: RouterNames.PoliticaPrivacidad,
    component: PoliticaPrivacidad,
    meta: {
      title: t('seo.politicaPrivacidad.title'),
      description: t('seo.politicaPrivacidad.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'legal/faqs',
    name: 'FAQS',
    component: Faqs,
    meta: {
      title: t('seo.faqs.title'),
      description: t('seo.faqs.description'),
    },
  },
  {
    path: vueConfig.publicPath + 'legal/condicionesCovid',
    name: 'CondicionesCovid',
    component: CondicionesCovid,
  },
  {
    path: vueConfig.publicPath + 'legal/politicaCamasLibres',
    name: 'PoliticaCamasLibres',
    component: PoliticaCamasLibres,
  },

  // NOSOTROS
  {
    path: vueConfig.publicPath + 'nosotros/trabajaConNosotros',
    name: 'TrabajaConNosotros',
    component: TrabajaConNosotros,
  },
  {
    path: vueConfig.publicPath + 'nosotros/quienesSomos',
    name: 'QuienesSomos',
    component: QuienesSomos,
  },

  {
    path: '/blog',
    name: 'BlogLanding',
    component: BlogLanding,
  },
  {
    path: '/blog/:blogUri',
    name: 'BlogLandingPost',
    component: blogPost,
  },
  //////////////////////////////////////////////////////////////
  ///////////////////     RESERVAS-PARATI    ///////////////////
  //////////////////////////////////////////////////////////////

  {
    path: vueConfig.publicPath + 'grupos/:grupoId/reserva/:reservaId/checkin',
    name: RouterNames.CheckIn,
    component: CheckInReserva,
    meta: { requiresLogin: true },
  },
  {
    path: vueConfig.publicPath + 'grupos/:grupoId/reservas/:reservaId/servicios/:codigoValidacion',
    name: RouterNames.ValidacionQrServicios,
    component: () => import('../views/reservas/ServiciosValidacionQr.vue'),
    meta: { requiresLogin: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error',
    component: NotFound,
  },
  // {
  //     path: '/about',
  //     name: 'About',
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: vueConfig.publicPath + 'comunidad/:grupoId/unirse/:codigo',
    name: RouterNames.UnirseAComunidad,
    component: () => import('@/views/comunidad/UnirseAComunidadView.vue'),
    // No ponemos requiresLogin porque queremos manejar nosotros los estados
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes: [...routes],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const storeGlobal = appGlobalStore();
  while (storeGlobal.permisos === null) {
    await new Promise(r => setTimeout(r, 100));
  }
  await redireccionRutas(to, next);
});

router.beforeEach((to, from, next) => {
  const loginStore = useLoginStore();
  const userStore = useUserStore();
  const tokerExpired = isTokenExpired();
  if (to.matched.some(record => record.meta.requiresLogin) && (!userStore.isLogged || tokerExpired)) {
    if (tokerExpired) {
      useUserStore().logout();
    }
    loginStore.openLoginModal(to.fullPath);
    next(vueConfig.publicPath);
  } else if (
    to.matched.some(record => record.meta.requiresLoginHomologados) &&
    agenciaStoreModule().usuariosHomologados &&
    !userStore.isLogged
  ) {
    loginStore.openLoginModal(to.fullPath);
    next(false);
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  const storeGlobal = appGlobalStore();
  document.title = storeGlobal.valores.meta_titulo || window.location.origin;
  if (document.querySelector("[name='description']")) {
    document.querySelector("[name='description']").remove();
  }
  var meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = storeGlobal.valores.meta_descripcion;
  document.getElementsByTagName('head')[0].appendChild(meta);
  next();
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
